var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundGradient2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 667,
    viewBox: "0 0 383 667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_75_1743)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_75_1743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525.35 172.047C486.66 258.202 385.745 347.036 370.796 397.281C348.687 437.482 366.308 452.378 357.621 492.555C344.143 556.378 315.617 624.928 243.123 580.629C155.503 504.485 112.529 416.007 136.173 353.963C151.813 296.49 201.638 242.517 263.957 222.278C332.133 191.602 498.005 127.328 525.35 172.047Z",
    fill: "#2346FA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_75_1743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.564 204.446C362.749 275.543 335.853 325.254 330.74 365.923C318.84 399.521 334.291 409.278 332.715 441.457C330.459 492.543 317.226 548.876 255.817 521.955C178.723 471.824 134.41 407.435 144.714 356.675C149.44 310.307 182.744 275.467 228.119 253.214C276.674 222.226 354.84 172.488 381.564 204.446Z",
    fill: "#00D1FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_75_1743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.801 175.508C321.926 242.749 295.693 289.964 290.255 328.346C278.481 360.165 292.998 369.133 291.038 399.467C288.16 447.619 274.793 500.874 216.929 476.403C144.519 430.295 103.414 370.285 113.922 322.322C119.075 278.577 151.171 245.279 194.536 223.662C241.043 193.771 315.912 145.792 340.801 175.508Z",
    fill: "#FF0B80"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M335.386 189.349C321.394 239.195 301.948 274.195 297.916 302.647C289.188 326.235 299.95 332.883 298.496 355.369C296.363 391.064 286.455 430.542 243.56 412.401C189.883 378.222 159.411 333.736 167.201 298.182C171.021 265.754 194.813 241.07 226.96 225.045C261.436 202.887 316.935 167.32 335.386 189.349Z",
    fill: "#FFFB69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.497 218.204C291.087 248.164 279.399 269.201 276.976 286.302C271.73 300.48 278.198 304.476 277.325 317.991C276.043 339.446 270.087 363.174 244.305 352.271C212.042 331.727 193.727 304.989 198.409 283.618C200.705 264.128 215.006 249.291 234.328 239.659C255.049 226.341 288.408 204.964 299.497 218.204Z",
    fill: "#FFFFFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_75_1743",
    x: 12.2952,
    y: 56.7085,
    width: 613.055,
    height: 638.025,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_75_1743"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_75_1743",
    x: 0.750488,
    y: 27.7085,
    width: 653.6,
    height: 696.025,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 64.5,
    result: "effect1_foregroundBlur_75_1743"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_75_1743",
    x: 91.2373,
    y: 142.137,
    width: 342.327,
    height: 438.78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26,
    result: "effect1_foregroundBlur_75_1743"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_75_1743",
    x: 60.2952,
    y: 114.156,
    width: 332.506,
    height: 420.397,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26,
    result: "effect1_foregroundBlur_75_1743"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundGradient2);
export default __webpack_public_path__ + "static/media/background-gradient2.a1f98e019e9364b84f76126e659a0695.svg";
export { ForwardRef as ReactComponent };